import api from "../api";

const state = {
  preOrderStatus: false,
  sending: false,
  response: []
};

const getters = {
  getPreOrderStatus: state => state.preOrderStatus,
  getSending: state => state.sending,
  getResponse: state => state.response
};

const mutations = {
  TOGGLE_PREORDER: (state, payload) => (state.preOrderStatus = payload),
  TOGGLE_SENDING: (state, payload) => (state.sending = payload),
  SET_RESPONSE: (state, payload) => (state.response = payload)
};

const actions = {
  togglePreOrder: ({ commit }, payload) => commit("TOGGLE_PREORDER", payload),

  sendPreOrder: async ({ commit }, payload) => {
    commit("TOGGLE_SENDING", true);
    let res = await api(
      "post",
      "/web/message/newsletter-subscription",
      payload
    );
    commit("TOGGLE_SENDING", false);
    commit("SET_RESPONSE", res);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
